module.exports = __webpack_public_path__ + "media/state-press_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press_2400.jpg
// module id = 51
// module chunks = 0